import { useEffect, useId } from 'react';
import NProgress from 'nprogress';

import IntlMessages from 'components/util/IntlMessages';

import { StyledSpinner } from './index.styled';

import 'nprogress/nprogress.css';

/** The spinner S2C uses: an arc fading into the theme's colour, turning. */
export const Spinner = ({ size = 30 }: { size?: number }) => {
    // Each spinner has its own gradient, so it never points at one that is not drawn.
    const gradientId = `efz-spinner-${useId().replace(/[^\w-]/g, '')}`;

    return (
        <StyledSpinner viewBox="0 0 81 81" width={size} height={size} aria-hidden="true">
            <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="0%">
                    <stop offset="0%" className="spinner-from" />
                    <stop offset="100%" className="spinner-to" />
                </linearGradient>
            </defs>
            <circle className="spinner-arc" cx="40.5" cy="40.5" r="34.5" transform="rotate(-90 40.5 40.5)" stroke={`url(#${gradientId})`} />
        </StyledSpinner>
    );
};

interface ILoadingProps {
    size?: number;
    className?: string;
    useTopLoading?: boolean;
    label?: string | null;
}

const Loading = ({ size = 30, className = '', useTopLoading = false, label = null }: ILoadingProps) => {
    NProgress.configure({ showSpinner: false, trickleSpeed: 30 });

    if (!!useTopLoading && !NProgress.isStarted()) NProgress.start();

    useEffect(() => {
        return () => {
            if (useTopLoading) NProgress.done();
        };
    }, [useTopLoading]);

    return (
        <div className={`loading-component${className ? ' ' + className : ''}`}>
            <Spinner size={size} />
            {label && (
                <label>
                    <IntlMessages id={label} />
                </label>
            )}
        </div>
    );
};

export default Loading;
